import { memo } from 'react';

interface PdfViewerProps {
  url: string | null;
  isLoading: boolean;
  title: string;
}

// Memoized PDF Viewer - only re-renders when url or isLoading changes
export const PdfViewer = memo(function PdfViewer({
  url,
  isLoading,
  title
}: PdfViewerProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full bg-gray-100 dark:bg-dark-recessed">
        <div className="text-center">
          <span className="inline-block w-8 h-8 border-2 border-purple-400 border-t-transparent rounded-full animate-spin mb-2" />
          <p className="text-gray-500 dark:text-gray-400">Loading PDF...</p>
        </div>
      </div>
    );
  }

  if (url) {
    // Add zoom parameter to default to 80% zoom
    const pdfUrl = url.includes('#') ? url : `${url}#zoom=80`;
    return (
      <iframe
        src={pdfUrl}
        className="w-full h-full border-0"
        title={title}
      />
    );
  }

  return (
    <div className="flex items-center justify-center h-full bg-gray-100 dark:bg-dark-recessed">
      <p className="text-gray-500 dark:text-gray-400">Failed to load PDF</p>
    </div>
  );
}, (prevProps, nextProps) => {
  // Only re-render if url or isLoading actually changed
  return prevProps.url === nextProps.url && prevProps.isLoading === nextProps.isLoading;
});
